export const CategoryNameValid = {
  categoryName: false,
}